import { GET_COLLECTION } from '../actions/index';

const INITIAL_STATE = {
  collection: null,
  error: null
};

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {

    case GET_COLLECTION:
    if(action.payload.status === 200) {
      return { ...state, collection: action.payload.data };
    } else{
      if(action.payload.response){
        if (action.payload.response.status === 400) {
          return { ...state, collection: action.payload.response };
        } if (action.payload.response.status === 401) {
          return { ...state, collection: action.payload.response };
        }
      } else {
        return { ...state, error: "No internet connection"}
      }
    }

    break;

  	default:
    	return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducerCollection.js